module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"shared":{"global":{"company_profiles":{"types":{"asset_manager":"Investment company","financial_service_provider":"Financial service provider","other":"Other","wealth_manager":"Wealth manager"}}}}}}}')
  delete Component.options._Ctor
}
